<template>
  <div class="category">
    <PageHeading
      :title="category.name"
      :subheading="context.name"
    />
    <v-list>
      <v-list-item v-for="(item, i) in items" :key="i" @click="singleItem(item)">
        <v-list-item-content>
          <v-list-item-title>
            <h3 class="label">{{ item.name }}</h3>
          </v-list-item-title>
          <ProgressBar
            :grade="item.grade"
            :goal="item.goal"
            :grade_color="category.grade_color"
            :goal_color="category.goal_color"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import ProgressBar from "@/components/ProgressBar.vue";
import PageHeading from "@/components/PageHeading.vue";

export default {
  name: "SingleCategory",
  components: {
    ProgressBar,
    PageHeading
  },
  data() {
    return {
      loading: true
    };
  },
  beforeMount() {
    if (!this.loggedIn)
      console.error("Tryied to load SingleCategory.vue without user logged in.");
  },
  computed: {
    group_id() { return this.$route.params.group_id; },
    context_id() { return this.$route.params.context_id; },
    context() { return this.$store.getters[`user/${this.group_id}/${this.context_id}/cached`]; },
    cat_id() { return this.$route.params.cat_id; },
    items() {
      if (this.context?.categories)
        return this.category.items;
      else
        return [];
    },
    category() {
      if (this.context?.categories)
        return this.context.categories.find(el => el.id === this.cat_id);
      else
        return {};
    },
    ...mapGetters([
      "loggedIn"
    ])
  },
  methods: {
    singleItem(item) {
      this.$router.push(`${this.cat_id}/item/${item.id}`)
    }
  }
};
</script>

<style lang="scss">
.category {
  .v-list-item__title {
    text-align: left;
  }
}
</style>
